import { useCallback } from "react";
import Icon from "../../commons/Icon";
import { serviceSync } from "../../../services/sync.service";

export type MessagingThreadNameProps = {
    name: string;
}

export default function MessagingThreadName({ name }: MessagingThreadNameProps) {
    const backClickHandler = useCallback(() => {
        serviceSync.closeMobileThread();
    }, []);

    return (
        <div className={`h-full flex items-center pl-[22px] font-bold text-gray-700`}>
            <div className="mt-[-5px] py-[5px] ml-[-5px] px-[5px] mr-[5px] text-gray-500 relative top-[2px] md:hidden active:bg-gray-200" onClick={backClickHandler}>
                <Icon className="relative top-[2px]" name="bxs-chevron-left" size="28px" />
            </div>
            {name}
        </div>
    );
}